module.exports = {
  "title": "engage",
  "sub_text": "what was said and done",
  "actions": {
    "all" : "All",
    "live" : "Live",
    "hours": "Last 24 hours",
    "days": " Last 7 days",
  },
  "description_card": {
    "title": "Here's what's happening",
    "sub_text": "We've not seen anyone live on your content yet. Start sharing and see how the map lights up.",
    "comment":"We've had {users} from {countries} spend a total of {timespent} across {assets}",
    "spent_over":"{name} has spent over {timespent} on your content.",
    "live_user":"live user",
    "live_users":"live users",
    "live_users_text":"There {end_user} {live_users} viewing your content",
    "is":"is",
    "are":"are",
    "country" :"country",
    "countries":"countries",
    "last":"In the last",
    "user_activity":"User Activity",
    "filters":{
      "hrs":"24hrs",
      "week": "1 week",
      "month" : "month"
    },
  },
  "viewers":{
    "title": "Viewers",
    "show_all_recipients" :"Show All {accountName}'s Recipients",
    "active_users":"Showing active viewers in the ",
    "live_now":"Live Now",
    "filters":{
      "hours":"last 24 hours",
      "week":"last 1 week:",
      "month" :"last month",
    },
    "options": {
      "my_recipients": "My recipients",
      "live_users" : "Live users",
      "unread_chats" : "Unread chats",
    },
    "headers":{
      "name": "Name",
      "account": "Account",
      "last_active": "Last Active",
      "location": "Location",
    }
  },
  "chat_view": {
    "title": "engage",
    "sub_text":"what was said and done",
    "show_all_recipients" :"Show All {accountName}'s Recipients",
    "options":{
      "my_recipients": "My recipients",
      "live_users" : "Live users",
      "unread_chats" : "Unread chats",
      "empty_message":{
        "no_activity":"Looks like there's no activity to show.",
      }
    },
    "viewers_card":{
      "online":"Online",
      "last_online":"Last online"
    }
  },
  "individual_chat":{
    "actions":{
      "block_recipient":"Block recipient",
      "participants":"Participants", 
      "slider":{
        "block_view":{
          "title":"{status} recipient",
          "block":"Block",
          "unblock":"Unblock",
          "block_sub_text":"Are you sure you would like to block the selected recipient?",
          "unblock_sub_text":"Are you sure you would like to unblock the selected recipient?"
        },
      }
    },
    "chat_details":{
      "last_online":"Last Online",
      "subject": "is currently offline",
      "description":"Don't worry though. Every message you send now will be delivered as an email to them.",
      "currently_viewing":"Currently viewing",
      "last_viewed":"Last viewed",
      "quicksend":"QuickSend",
      "chat": {
        "placeholder": "Write a message",
      },
      "blocked":{
        "title":"This recipient has been blocked.",
        "sub_text":"If you've changed your mind, hit the Unblock button below.",
        "unblock":"Unblock"
      },
      "sliders":{
        "shared_asset":"You've shared {0}",
        "shared_time":"shared {createdDate} via {conversationSource}",
        "observing_page":" Observing page"
      }
    }
  },
    "empty_message": {
      "title": "Where is everybody?",
      "no_recipients":"Looks like you've not initiated a conversation yet. Go on, say hi!",
      "no_live_users":"Looks like nobody's active right now. Check back in a while?",
      "unread_chats":"You're caught up with all your conversations. Go share some more content!"
    }

}  

